import React, { Component } from "react";
import { Alert, Button } from "react-bootstrap";

const PUSH_API_URL = "/push-api/";
const DISMISS_KEY = "mangusta-push-prompt-dismissed-at";
const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function isSupported() {
  return (
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

function wasRecentlyDismissed() {
  try {
    const timestamp = Number(window.localStorage.getItem(DISMISS_KEY));
    return timestamp > 0 && Date.now() - timestamp < DISMISS_DURATION_MS;
  } catch (error) {
    return false;
  }
}

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from(Array.prototype.map.call(raw, char => char.charCodeAt(0)));
}

class PushNotificationPrompt extends Component {
  state = {
    visible: false,
    busy: false,
    error: "",
    vapidPublicKey: ""
  };

  componentDidMount() {
    window.addEventListener("appinstalled", this.handleInstalled);
    this.checkInstalledApplication();
  }

  componentWillUnmount() {
    window.removeEventListener("appinstalled", this.handleInstalled);
  }

  post = body =>
    fetch(PUSH_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...body,
        auth: this.props.credentials
      })
    }).then(response =>
      response.json().then(payload => {
        if (!response.ok || !payload.ok)
          throw new Error(payload.error || `Błąd HTTP ${response.status}`);
        return payload;
      })
    );

  checkInstalledApplication = () => {
    if (!this.props.credentials || !isSupported()) return;
    Promise.all([
      this.post({ action: "status" }),
      navigator.serviceWorker.ready.then(registration =>
        registration.pushManager.getSubscription()
      )
    ])
      .then(([payload, subscription]) => {
        this.setState({
          vapidPublicKey: payload.vapid_public_key || ""
        });
        if (
          isStandalone() &&
          Notification.permission === "default" &&
          !subscription &&
          !wasRecentlyDismissed()
        ) {
          this.setState({ visible: true });
        }
      })
      .catch(() => {});
  };

  handleInstalled = () => {
    if (
      isSupported() &&
      Notification.permission === "default" &&
      !wasRecentlyDismissed()
    ) {
      this.loadConfiguration();
    }
  };

  loadConfiguration = () => {
    this.post({ action: "status" })
      .then(payload =>
        this.setState({
          visible: true,
          vapidPublicKey: payload.vapid_public_key || "",
          error: ""
        })
      )
      .catch(() => {});
  };

  enable = () => {
    this.setState({ busy: true, error: "" });
    let registration;
    navigator.serviceWorker.ready
      .then(value => {
        registration = value;
        return Notification.requestPermission();
      })
      .then(permission => {
        if (permission !== "granted")
          throw new Error("Nie udzielono zgody na powiadomienia.");
        return registration.pushManager.getSubscription();
      })
      .then(subscription => {
        if (subscription) return subscription;
        return registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(
            this.state.vapidPublicKey
          )
        });
      })
      .then(subscription =>
        this.post({
          action: "subscribe",
          subscription: subscription.toJSON()
        })
      )
      .then(() => this.setState({ visible: false, busy: false }))
      .catch(error =>
        this.setState({
          busy: false,
          error: error.message || String(error)
        })
      );
  };

  dismiss = () => {
    try {
      window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch (error) {
      // The prompt remains hidden for this page when storage is unavailable.
    }
    this.setState({ visible: false, error: "" });
  };

  render() {
    if (!this.state.visible) return null;
    return (
      <div
        style={{
          position: "fixed",
          left: 15,
          right: 15,
          bottom: 15,
          zIndex: 10010,
          maxWidth: 620,
          margin: "0 auto"
        }}
      >
        <Alert bsStyle={this.state.error ? "danger" : "info"}>
          <button type="button" className="close" onClick={this.dismiss}>
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Zamknij</span>
          </button>
          <strong>Czy chcesz otrzymywać alarmy jako powiadomienia PUSH?</strong>
          <br />
          Mangusta24 może informować o alarmach również wtedy, gdy aplikacja
          nie jest otwarta.
          {this.state.error && (
            <React.Fragment>
              <br />
              {this.state.error}
            </React.Fragment>
          )}
          <div style={{ marginTop: 10 }}>
            <Button
              bsStyle="info"
              bsSize="small"
              disabled={this.state.busy || !this.state.vapidPublicKey}
              onClick={this.enable}
            >
              {this.state.busy ? "Włączanie…" : "Włącz powiadomienia"}
            </Button>{" "}
            <Button bsStyle="default" bsSize="small" onClick={this.dismiss}>
              Nie teraz
            </Button>
          </div>
        </Alert>
      </div>
    );
  }
}

export default PushNotificationPrompt;



// WEBPACK FOOTER //
// ./src/components/PushNotificationPrompt/PushNotificationPrompt.jsx